export interface AddressbookCountryOption {
  label: string;
  value: string;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/**
 * Country values come from legacy RTDB records, so validate the runtime value
 * even though current account forms require a country.
 */
export const normalizeAddressbookCountry = (value: unknown): string => {
  if (
    typeof value !== 'string' ||
    value.length === 0 ||
    value !== value.trim()
  ) {
    return '';
  }

  return value.toUpperCase();
};

/** Ignore malformed country enumeration records rather than crashing a modal. */
export const getAddressbookCountryOptions = (
  countries: unknown
): AddressbookCountryOption[] => {
  if (!isRecord(countries) && !Array.isArray(countries)) {
    return [];
  }

  const options = new Map<string, AddressbookCountryOption>();
  for (const country of Object.values(countries)) {
    if (!isRecord(country)) {
      continue;
    }

    const value = normalizeAddressbookCountry(country.value);
    if (!value) {
      continue;
    }

    options.set(value, {
      label: typeof country.label === 'string' ? country.label : value,
      value,
    });
  }

  return Array.from(options.values());
};
